<template>
   <div>
      <v-container>
         <v-toolbar color="primary white--text" bottom>
            <v-toolbar-title>
               <template v-if="$vuetify.breakpoint.mdAndUp">
                  Attendance:
               </template>
               {{ this.$route.params.eventdate }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn color="indigo" class="white" outlined @click="goBack()">
               Back
            </v-btn>
         </v-toolbar>
         <div v-for="pcp in participants" :key="pcp.school_id">
            <attendance :student="pcp" @save-attend="SaveAttendance" />
         </div>
      </v-container>
   </div>
</template>

<script>
   import attendance from "@/components/attendance";

   export default {
      components: {
         attendance: attendance,
      },
      data() {
         return {
            participants: [],
            eventid: -1,
            ccaid: -1,
            eventdate: "",
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },
         async doLoadParticipant() {
            let response = await this.$http({
               url: "/cca/geteventparticipant.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  eventid: this.$route.params.eventid,
                  ccaid: this.$route.params.ccaid,
               },
               method: "POST",
            }).then((response) => {
               console.log(response);
               if (!response.data.error) {
                  this.participants = response.data.participantdata;
               }
            });
            console.log(response);
         },

         async updateAttendance(studentattendance) {
            let attend = {
               eventid: this.eventid,
               ccaid: this.ccaid,
               schoolid: studentattendance.school_id,
               attend: studentattendance.attend,
               submitby: this.$globalstore.user.userid,
            };
            let response = await this.$http({
               url: "/cca/saveattendance.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: attend,
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  console.log("Error updating attendance");
               }
            });
         },

         SaveAttendance(studentattendance) {
            // console.log(
            //    `Parent Id = ${studentattendance.school_id} value = ${studentattendance.attend}`
            // );
            this.updateAttendance(studentattendance);
         },
      },
      mounted() {
         this.eventid = this.$route.params.eventid;
         this.ccaid = this.$route.params.ccaid;
         this.eventdate = this.$route.params.eventdate;

         this.doLoadParticipant();
      },
   };
</script>
